export enum EesePollResult{
    REQ = 'REQ',
    VHFCN = 'VHFCN'
}
